import { render, staticRenderFns } from "./Chi_threeColumnSection.vue?vue&type=template&id=217a23ef&scoped=true"
import script from "./Chi_threeColumnSection.vue?vue&type=script&lang=ts"
export * from "./Chi_threeColumnSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a23ef",
  null
  
)

export default component.exports